var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-table',{attrs:{"resource":_vm.resource,"columns":_vm.columns,"tbody-tr-class":_vm.rowClass,"hide-per-page":"","suppress-route-handling":""}})}
var staticRenderFns = []

export { render, staticRenderFns }